import { Banner } from "@/components/flexkit/Banner";
import { cn } from "@/components/podkit/lib/cn";

function FreeCreditsPromotionBanner({ className }: { className?: string }) {
    return (
        <Banner
            className={cn("flex w-full text-content-primary lg:text-lg [&>div]:justify-center", className)}
            text="Get $100 in free credits in our Core tier when you upgrade for the first time (ending soon). Free credit grant must be used within 3 months."
            variant="info"
            role="alert"
            aria-live="assertive"
            LeadingIcon={null}
        />
    );
}

export default FreeCreditsPromotionBanner;
